import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

function RadioButton({ name, label, value, onChange, disabled = null }) {
  const _onChange = useCallback(() => {
    onChange({ target: { name, value: !value } });
  }, [onChange, name, value]);

  return (
    <Form.Check
      type="checkbox"
      className={disabled ? null : 'pointer'}
      disabled={disabled}
      checked={value}
      onChange={_onChange}
      id={name + value}
    >
      <Form.Check.Input
        className={disabled ? null : 'pointer'}
        id={name + value}
        disabled={disabled}
        checked={value}
        onChange={_onChange}
        type="checkbox"
      />
      <Form.Check.Label className={disabled ? null : 'pointer'} id={name + value}>
        {label}
      </Form.Check.Label>
    </Form.Check>
  );
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RadioButton;
